
<script setup>
import { storeToRefs } from "pinia";
  import { ref, onBeforeMount, computed } from "vue";
  import { useUiStore } from "@/stores/ui";
  import { useDevicesStore } from "@/stores/devices";
import { useCompanyStore } from "@/stores/company";
  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const devicesStore = useDevicesStore();

  // const global_user_name = inject(['global_user_name']);
  const user = ref(JSON.parse(localStorage.getItem("userDetails")));

  let isSubmitted = ref(false);
  let name = ref(null);
  let mac_address = ref(null);
  let apps = ref([]);
  let appsOptions = ref([]);
  let isLoading = ref(true);
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);
  const { companyId: company_id } = storeToRefs(useCompanyStore());

  const onSubmit = () => {
    isSubmitted.value = true;

    let packagesArr = [];

    apps.value.map((app) => {
      packagesArr.push(app.packageId)
    });

    let data = { 
      entityId: company_id.value,
      kioskName : name.value,
      macAddress : mac_address.value,
      userName : user.value.first_name+' '+ user.value.last_name,
      userId : user.value.user_id,
      connectionType : 'daemon',
      packages : packagesArr,
    }

    devicesStore.uninstallApp(data)
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () =>{
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'uninstall_apps'){
      name.value = getModalInfo.value.name;
      mac_address.value = getModalInfo.value.mac_address;

      let data = { 
        entityId: company_id.value,
        kioskName : getModalInfo.value.name,
        macAddress : getModalInfo.value.mac_address,
        userName : user.value.first_name+' '+ user.value.last_name,
        userId : user.value.user_id,
        connectionType : 'daemon',
      }

      devicesStore.fetchInstalledAppsGrid(data)
      .then((res) => {
        appsOptions.value = JSON.parse(res.data);
        isLoading.value = false;
      })
      .catch(() => {
      });
    }
  });

</script>

<template>
  <DModal v-if="getModalAction === 'uninstall_apps'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Uninstall Apps </template>

    <template #body>
      <div class="delete-text mb-3">
        <span>Select the applications you want to  <b>"Uninstall"</b> on the device "{{ name }}" ?</span>
      </div>

      <div class="relative mb-3">
        <span v-if="apps.length" class="multiselect-title-span">Applications</span>
        <VMultiselect :class="{'multiselect-options' : apps.length}" v-model="apps" :options="appsOptions" :disabled="!appsOptions.length" :multiple="true"
          :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Applications" trackBy="packageId" label="name" :loading="isLoading"
        />
      </div>

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!apps.length || isSubmitted " 
          @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Uninstall <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
